module.exports = __webpack_public_path__ + "img/tu_file_png.8a14f52a.svg";